import { useState } from "react";

import { useTranslation } from "react-i18next";

import Modal from "../../../../layouts/Modal";
import { ILead } from "../../../../models/Lead";
import DropOffPlannerView from "../../../dropOffPlanner/DropOffPlannerView";
import { ButtonInput } from "../../../shared/Inputs/ButtonInput";

interface BookDropOffModalProps {
  currentLead?: ILead;
}

export function BookDropOffModal({ currentLead }: BookDropOffModalProps) {
  const { t } = useTranslation("leads");
  const [open, setOpen] = useState(false);

  const handleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(true);
  };

  return (
    <>
      <ButtonInput
        label={t("Book Drop Off")}
        isSubmit={false}
        onClick={(e: React.MouseEvent) => handleOpen(e)}
        classes="!px-2 !py-1 !text-sm"
      />
      <Modal width="max-w-7xl" open={open} setOpen={setOpen}>
        <DropOffPlannerView
          currentLeadId={currentLead?.id}
          containerClassName="flex flex-col gap-2 h-[75vh]"
        />
      </Modal>
    </>
  );
}
